import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, effect, Input, signal, Signal } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html'
})
export class LoadingComponent {
  @Input() title: string = 'Chargement...';
  @Input() message: string = 'Veuillez patienter...';
  @Input() icon: string = 'pi pi-spin pi-spinner';
  @Input() httpEvent: Signal<HttpEvent<any>> = signal(null);
  @Input() error: Signal<string> = signal(null);

  progress: number = 0;

  constructor(private http: HttpClient) {
    this.httpEvent = signal(null);

    effect(() => {
      if (this.httpEvent()) {
        let event = this.httpEvent();
        switch (event.type) {
          case HttpEventType.DownloadProgress:
            this.progress = (event.loaded / event.total) * 100;
            break;
          case HttpEventType.UploadProgress:
            this.progress = (event.loaded / event.total) * 100;
            break;
          case HttpEventType.Response:
            this.progress = 100;
            break;
          default:
            this.progress = 0;
            break;
        }
      }
    });
  }
}
